import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { SelectField, SingleFilePickerField } from '../../components'
import { Button } from '../../elements'
import { listSchedules } from 'redux/modules/model/attendance'
import withClientId from 'hocs/with-client-id'
import { createStructuredSelector } from 'reselect'
import { schedulesSelector } from 'redux/selectors'
import { compose } from 'redux'
import { connect } from 'react-redux'

import validate from './validate'

class ImportsForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  }

  componentWillMount() {
    const { clientId, listSchedules } = this.props
    listSchedules({ clientId })
  }

  render() {
    const { isSubmiting, handleSubmit, onSubmit, schedules } = this.props
    const schedulesId = []

    schedules.forEach(schedule => {
      schedulesId.push(schedule.scheduleId)
    })
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field
          name="type"
          label="Type"
          id="type"
          options={['Moodle']}
          disabled={isSubmiting}
          component={SelectField}
        />

        <Field
          name="scheduleId"
          label="Schedule Id"
          id="scheduleId"
          options={schedulesId}
          disabled={isSubmiting}
          component={SelectField}
        />

        <Field
          name="file"
          label="File"
          id="file"
          disabled={isSubmiting}
          component={SingleFilePickerField}
        />

        <Button loading={isSubmiting} htmlType="submit" type="primary">
          Import
        </Button>
      </form>
    )
  }
}

const selector = createStructuredSelector({
  schedules: schedulesSelector
})

const actions = {
  listSchedules
}

export default compose(
  withClientId,
  connect(selector, actions),
  reduxForm({
    form: 'imports',
    validate,
  })
)(ImportsForm)



// WEBPACK FOOTER //
// ./src/smart-components/imports-form/index.js